module.exports = __webpack_public_path__ + "img/user1.c74450cd.png";